import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { noop } from 'rxjs';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ticketing-counter',
  imports: [NgClass],
  templateUrl: './counter.component.html',
  styleUrl: './counter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CounterComponent implements ControlValueAccessor {
  displayNumber = input<number>();
  state = input.required<number>();

  internalDisplayNumber = computed(() => this.displayNumber() ?? this.state());

  currentNumberChange = output<number>();
  canIncrease = input<boolean>(true);
  canDecrease = input<boolean>(true);

  isDisabled = signal<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  regOnChange = (_: never) => noop;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  regOnTouched = (_: never) => noop;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  writeValue(_: never): void {
    /* empty */
  }

  registerOnChange(fn: never): void {
    this.regOnChange = fn;
  }

  registerOnTouched(fn: never): void {
    this.regOnTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }
}
